import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/svgs/tax-loading.svg';
import _imports_1 from '@/assets/svgs/credit-card.svg';
const _hoisted_1 = {
  class: "step4-container"
};
const _hoisted_2 = {
  class: "step4-row step4-price-row"
};
const _hoisted_3 = {
  class: "step4-value"
};
const _hoisted_4 = {
  class: "step4-row"
};
const _hoisted_5 = {
  class: "step4-value",
  style: {
    "display": "flex",
    "align-items": "center"
  }
};
const _hoisted_6 = {
  key: 1
};
const _hoisted_7 = {
  class: "step4-row"
};
const _hoisted_8 = {
  class: "step4-total-value"
};
const _hoisted_9 = {
  class: "step4-desc"
};
import { ref, watch } from "vue";
export default {
  __name: 'step-4',
  props: {
    taxAmount: Number,
    taxLoading: Boolean,
    isFormValid: Boolean,
    productInfo: Object
  },
  emits: ["update:form"],
  setup(__props, {
    emit: __emit
  }) {
    const checked1 = ref(false);
    const checked2 = ref(false);
    const emit = __emit;
    watch([checked1, checked2], () => {
      emit("update:form", {
        checked1: checked1.value,
        checked2: checked2.value
      });
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "step4-title"
      }, [_createTextVNode("Step "), _createElementVNode("span", null, "4"), _createTextVNode(":")], -1)), _cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "step4-subtitle"
      }, "Cofirm your order", -1)), _createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "step4-label"
      }, "Subscription Price", -1)), _createElementVNode("div", _hoisted_3, _toDisplayString(__props.productInfo?.currency) + _toDisplayString(__props.productInfo.price), 1)]), _createElementVNode("div", _hoisted_4, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "step4-label"
      }, "Tax", -1)), _createElementVNode("div", _hoisted_5, [!__props.isFormValid ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(" TBD ")], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [__props.taxLoading ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0,
        class: "is-loading",
        size: "20",
        style: {
          "margin-right": "4px"
        }
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("img", {
          src: _imports_0,
          alt: "loading"
        }, null, -1)])),
        _: 1,
        __: [3]
      })) : _createCommentVNode("", true), !__props.taxLoading ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.taxAmount !== null ? `$${__props.taxAmount}` : "TBD"), 1)) : _createCommentVNode("", true)], 64))])]), _cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "step4-divider"
      }, null, -1)), _createElementVNode("div", _hoisted_7, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "step4-total-label"
      }, "Total", -1)), _createElementVNode("div", _hoisted_8, [__props.isFormValid && !__props.taxLoading && __props.taxAmount !== null ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createTextVNode(_toDisplayString(__props.productInfo?.currency + (__props.productInfo?.price + Number(__props.taxAmount)).toFixed(2)), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_createTextVNode(_toDisplayString(__props.productInfo?.currency) + _toDisplayString(__props.productInfo?.price), 1)], 64))])]), _createElementVNode("div", _hoisted_9, " After you click the ‘Place My Order’ button, we will create a Trucker Path account for you and apply the membership if you don’t have one. The subscription will automatically renew unless you cancel. If you are still a Northland policyholder, your renewal price will remain " + _toDisplayString(__props.productInfo?.currency) + _toDisplayString(__props.productInfo.price) + ", plus tax. Otherwise, you will be charged the Diamond plan price at the time of renewal. ", 1), _cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "step4-pay-row"
      }, [_createElementVNode("span", null, "Pay with your credit card via Stripe"), _createElementVNode("img", {
        src: _imports_1,
        alt: "credit card",
        class: "credit-card-icon"
      })], -1)), _createVNode(_component_el_checkbox, {
        modelValue: checked1.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => checked1.value = $event),
        class: "step4-checkbox"
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" I have read and accept the "), _createElementVNode("a", {
          href: "https://truckerpath.com/terms-of-service/",
          target: "_blank"
        }, "Term of Service", -1)])),
        _: 1,
        __: [6]
      }, 8, ["modelValue"]), _createVNode(_component_el_checkbox, {
        modelValue: checked2.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => checked2.value = $event),
        class: "step4-checkbox"
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode(" I have read and accept "), _createElementVNode("a", {
          href: "https://stripe.com/zh-us/legal/ssa",
          target: "_blank"
        }, "Stripe Payment Terms", -1)])),
        _: 1,
        __: [7]
      }, 8, ["modelValue"])]);
    };
  }
};